export function validarPorcentaje(e) {
  e > 100 ? this.porcentajeMax = true :  this.porcentajeMax = false;
}